import React from 'react';
import ProductList from '../../components/ProductList';

const Products = () => {
    
  return (
    <>
      <div className='container m-auto p-10 relative'>
        <h1>Products</h1>
        <ProductList />
      </div>
    </>
  )
}

export default Products